module.exports = __webpack_public_path__ + "img/fondo-audiovisivo-fvg.ec231faf.svg";